/**
 * Partial Registration Popup - Shows when user tries to enroll with incomplete registration
 */

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './PartialRegistrationPopup.module.css';

const PartialRegistrationPopup = ({ isOpen, onClose }) => {
  const [countdown, setCountdown] = useState(3);
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) {
      setCountdown(3);
      
      const timer = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(timer);
            navigate('/register');
            onClose();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [isOpen, navigate, onClose]);

  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        {/* Spinner */}
        <div className={styles.spinner} />

        <h2 className={styles.title}>
          Registration Required
        </h2>

        <p className={styles.message}>
          You need to complete your parent registration before enrolling in programs.
        </p>

        <div className={styles.countdownBox}>
          <p className={styles.countdownText}>
            Redirecting to registration in {countdown} second{countdown !== 1 ? 's' : ''}...
          </p>
        </div>

        <div className={styles.buttonContainer}>
          <button
            onClick={() => {
              navigate('/register');
              onClose();
            }}
            className={styles.primaryButton}
          >
            Continue Now
          </button>

          <button
            onClick={onClose}
            className={styles.secondaryButton}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default PartialRegistrationPopup;
